var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 308,
    height: 153,
    viewBox: "0 0 308 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    clipPath: "url(#clip0_15_938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.559 0.623535C69.6185 0.623535 0.907227 34.5424 0.907227 76.4727C0.907227 118.299 69.6185 152.322 154.559 152.322C239.289 152.322 308.211 118.403 308.211 76.4727C308 34.5424 239.289 0.623535 154.559 0.623535ZM154.559 147.432C75.0985 147.432 10.8134 115.698 10.8134 76.4727C10.8134 37.2476 75.0985 5.51368 154.559 5.51368C234.02 5.51368 298.305 37.2476 298.305 76.4727C298.305 115.594 233.809 147.432 154.559 147.432Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.56 16.9587C88.1674 16.9587 34.2101 43.5944 34.2101 76.3687C34.2101 109.143 88.1674 135.779 154.56 135.779C220.953 135.779 274.91 109.247 274.91 76.4728C274.91 43.5944 220.953 16.9587 154.56 16.9587ZM154.56 126.727C98.2844 126.727 52.5472 104.149 52.5472 76.3687C52.5472 48.5886 98.2844 26.0107 154.56 26.0107C210.836 26.0107 256.573 48.5886 256.573 76.3687C256.573 104.149 210.836 126.727 154.56 126.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.56 43.074C117.253 43.074 86.9023 58.0565 86.9023 76.4726C86.9023 94.8886 117.043 109.871 154.56 109.871C191.866 109.871 222.217 94.8886 222.217 76.4726C222.006 58.0565 191.866 43.074 154.56 43.074ZM154.56 94.3684C134.536 94.3684 118.307 86.3569 118.307 76.4726C118.307 66.5883 134.536 58.5768 154.56 58.5768C174.583 58.5768 190.812 66.5883 190.812 76.4726C190.812 86.3569 174.583 94.3684 154.56 94.3684Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_938"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 307.093,
    height: 151.594,
    fill: "white",
    transform: "translate(0.907227 0.623535)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.ab5937a0cc75000e61f0887f1ccbffeb.svg";
export { ForwardRef as ReactComponent };